/**
 * API origin for Axios and the home screen footer.
 * Dev (`npm run dev`) uses VITE_BASE_API_URL_DEV; production build uses VITE_BASE_API_URL_PROD.
 * Set both in `.env` (Vite exposes only `VITE_*` to client code).
 */
export const API_BASE_URL = import.meta.env.PROD
  ? import.meta.env.VITE_BASE_API_URL_PROD
  : import.meta.env.VITE_BASE_API_URL_DEV;
